/**
 * Warning: this is a PARTIAL copy of "abcstrategie/cogaa" project's file.
 * Each update of the main project should be manually made.
 */

export default {
  /**
   * Perform a HTTP request.
   * @param method
   * @param url
   * @param token
   * @param data
   * @return {Promise<Response>}
   */
  request (method, url, token, data) {
    // Default options are marked with *
    return fetch(url, {
      body: JSON.stringify(data), // Must match 'Content-Type' header
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: "same-origin", // include, same-origin, *omit
      headers: {
        'Content-Type': 'application/json',
        'Authorization': typeof token !== 'undefined' ? `Bearer ${token}` : '',
        'Access-Control-Allow-Origin': '*'
      },
      method, // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      redirect: 'follow' // manual, *follow, error
    })
  },

  /**
   * Perform a HEAD request.
   * @param url
   * @param token
   * @param data
   * @return {*|Promise<Response>}
   */
  head (url, token, data) {
    return this.request('HEAD', url, token, data)
  },

  /**
   * Perform a OPTIONS request.
   * @param url
   * @param token
   * @param data
   * @return {*|Promise<Response>}
   */
  options (url, token, data) {
    return this.request('OPTIONS', url, token, data)
  },

  /**
   * Perform a GET request.
   * @param url
   * @param token
   * @param data
   * @return {*|Promise<Response>}
   */
  get (url, token, data) {
    return this.request('GET', url, token, data)
  },

  /**
   * Perform a PUT request.
   * @param url
   * @param token
   * @param data
   * @return {*|Promise<Response>}
   */
  put (url, token, data) {
    return this.request('PUT', url, token, data)
  },

  /**
   * Perform a POST request.
   * @param url
   * @param token
   * @param data
   * @return {*|Promise<Response>}
   */
  post (url, token, data) {
    return this.request('POST', url, token, data)
  },

  /**
   * Perform a DELETE request.
   * @param url
   * @param token
   * @param data
   * @return {*|Promise<Response>}
   */
  delete (url, token, data) {
    return this.request('DELETE', url, token, data)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/client.js